import { gql } from 'graphql-request';
import { onMount, createSignal, useContext, createEffect } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';
import { Button } from '../../ui-components/button/button';
import { Modal } from '../../ui-components/modal/modal';
import { Text } from '../../ui-components/text/text';
import { VerticalSpace } from '../../ui-components/utility-style-components/spacing';
import { createStore } from 'solid-js/store';

export const GET_ANNOUNCEMENT_QUERY = gql`
    query {
        settings: resource(externalId: "announcement-settings") {
            content
        }
    }
`;

export const Announcement = () => {
    const { localize, announcement, registerUserHasSeenAnnouncement, createCachedResource } = useContext(AppContext);
    const [ showModal, setShowModel ] = createSignal(false);
    const [ closeBtnRef, setCloseBtnRef ] = createSignal<HTMLElement | undefined>();

    const [ message, setMessage ] = createStore({
        title: '',
        body: '',
        buttonText: '',
    });

    const [ announcementSettings ] = createCachedResource(GET_ANNOUNCEMENT_QUERY, {}, true);

    onMount(() => {
        const settings = announcementSettings()?.settings?.content;

        if (!settings) {
            return;
        }
        const { enabled, title, body, buttonText, announcementStart, announcementEnd } = settings;
        const noMessage = !title && !body;

        if (!enabled || noMessage) {
            return;
        }

        if (announcement.seen) {
            return;
        }

        const now = new Date();

        const start = new Date(announcementStart);
        const end = new Date(announcementEnd);

        const hasValidStartTime = start.getTime() !== 0 && !isNaN(start.getTime());
        const hasValidEndTime = end.getTime() !== 0 && !isNaN(end.getTime());

        const isBeforeStart = now < start;
        const isAfterEnd = now >= end;

        if (hasValidStartTime && isBeforeStart) {
            return;
        }

        if (hasValidEndTime && isAfterEnd) {
            return;
        }

        setMessage({ title, body, buttonText });
        setTimeout(() => {
            setShowModel(true);
        }, 4000);
    });

    createEffect(() => {
        if (closeBtnRef()) {
            closeBtnRef()?.focus();
        }
    });

    const closeAnnouncement = () => {
        saveCookie();
        registerUserHasSeenAnnouncement();
        setShowModel(false);
    };

    const saveCookie = async () => {
        await fetch('/set-announcement-seen', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ seenAnnouncement: true }),
        });
    };

    return (
        <Modal visible={showModal()} onClose={() => closeAnnouncement()} size='small' darkenBackground={true}>
            <VerticalSpace size={5} />
            <Text fontSize='large' fontStyle='bold'>
                {message.title}
            </Text>

            <Text fontSize='normal' splitParagraph={true}>
                {message.body}
            </Text>
            <Button
                label={message.buttonText || localize('close', 'Close')}
                onClick={closeAnnouncement}
                element={(el: HTMLElement) => {
                    setCloseBtnRef(el);
                }}
            />
        </Modal>
    );
};
